<script lang="ts" setup>

import {useMenu} from "~/composables/useMenu";

const {isAuthenticated, firstName, signOut} = useAuth()
const {isMobile} = useWindowSize()
const {navigateToOrSignIn, signInModal} = useRedirectLogin()
const {consumerMenuItems} = useMenu()

</script>
<template>
  <!-- Header Section starts -->
  <header class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
    <div class="container">
      <nuxt-link class="navbar-brand me-0 me-xl-4" to="/">
        <img class="d-block" src="@/assets/img/logo/logo_white.png" width="50" alt="Seu Rolê"/>
      </nuxt-link>

      <div class="d-flex align-items-center order-lg-3">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#search-btn"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Search navigation">
          <span class="fi-search"></span>
        </button>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#menu-btn"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Menu navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <button class="btn text-primary btn-sm ms-2 me-2 order-lg-3 d-none d-md-block"
                @click="() => navigateToOrSignIn('/produtor/eventos/adicionar')">
          <i class="fi-plus-circle" style="margin: 3px"></i> Criar Evento
        </button>

        <a v-if="!isAuthenticated" class="btn btn-sm text-primary order-lg-3" @click="signInModal">
          <i class="fi-user me-1 mt-1"></i>Entrar
        </a>
        <div v-else :class="{'dropdown-toggle': !isMobile,  'dropdown' : !isMobile}"
             class="order-lg-3 my-n2 me-3 text-primary">
            <a v-if="!isMobile" class="btn btn-sm text-primary order-lg-3 p-0" data-bs-toggle="dropdown" aria-expanded="false">
              {{ firstName }}
            </a>
          <div v-if="!isMobile" class="dropdown-menu dropdown-menu-end">
            <UserIdentityMenu :is-dark="false" />
            <nuxt-link v-for="(item, k) in consumerMenuItems" :key="k" class="dropdown-item" :to="item.link">
              <Icon :icon="item.icon" class="icon-menu"/>
              {{ item.title }}
            </nuxt-link>
            <NuxtLink class="dropdown-item" to="/" @click="signOut">
              <Icon icon="icomoon-free:exit" class="icon-menu"/>
              Sair
            </NuxtLink>
          </div>
        </div>
      </div>

      <div v-if="isMobile" class="collapse navbar-collapse" id="menu-btn">
        <div class="navbar-nav navbar-nav-scroll w-100">
          <div v-if="isAuthenticated">
            <UserIdentityMenu :is-dark="true" />
          </div>
          <button class="nav-item btn btn-sm ms-2 p-2 justify-content-start"
                  @click="() => navigateToOrSignIn('/produtor/eventos/adicionar')">
            <i class="fi-plus me-2 mt-1"></i>Criar Evento
          </button>
          <template v-if="isAuthenticated">
            <nuxt-link v-for="(item, k) in consumerMenuItems" :key="k"
                       class="nav-item btn btn-sm ms-2 p-2 justify-content-start" :to="item.link">
              <Icon :icon="item.icon" class="icon-menu"/>
              {{ item.title }}
            </nuxt-link>
            <NuxtLink class="nav-item btn btn-sm ms-2 p-2 justify-content-start" to="/" @click="signOut">
              <Icon icon="icomoon-free:exit" class="icon-menu"/>
              Sair
            </NuxtLink>
          </template>
        </div>
      </div>

      <div class="collapse navbar-collapse w-100" id="search-btn">
        <ul class="navbar-nav navbar-nav-scroll w-100 flex-column">
          <li class="nav-item p-0 ms-2">
            <NavFilter/>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>
